import React from 'react';
import { isVideoFormat } from '../../../utils';

export default function BannerTableShowFile({ autoPlay, fileUrl, maxHeight = '120px' }) {
  if (!fileUrl) return <></>;
  const isVideo = isVideoFormat(fileUrl);

  return isVideo ? (
    <video
      muted
      playsInline
      autoPlay={autoPlay}
      loop={autoPlay}
      style={{ maxWidth: '100%', maxHeight: maxHeight }}>
      <source src={fileUrl} type="video/mp4" />
    </video>
  ) : (
    <img src={fileUrl} style={{ maxWidth: '100%', maxHeight: maxHeight }} />
  );
}
